module.exports = __webpack_public_path__ + "media/images/flags/64/Antarctica-97a6ebe175cd7f2a12391c4efc676a8e.png";